import React from 'react';
import styled from '@emotion/styled';

import { Overlay } from '../styled-components';
import SavingSpinner from './SavingSpinner';

const LoadingOverlay = styled(Overlay)`
  align-items: center;
  display: flex;
  flex-direction: column;
  font-size: 60px;
  justify-content: center;
  padding: 20px;
`;

const OverlayText = styled.p`
  font-size: 16px;
  margin-top: 10px;
  text-align: center;
`;

export interface SavingOverlayProps {
  text: string;
}

const SavingOverlay: React.FC<SavingOverlayProps> = ({ text }) => {
  return (
    <LoadingOverlay>
      <SavingSpinner />
      <OverlayText>{text}</OverlayText>
    </LoadingOverlay>
  );
};

export default SavingOverlay;
